import { RootStore, withInjectedRootStore } from 'providers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextButton } from '@wix/design-system';

const getKBUrl = (locale: string) =>
  `https://support.wix.com/${locale}/article/wix-studio-faqs-using-editor-x`;

interface BannerButtonProps {
  rootStore: RootStore;
}

const BannerButtonComp: React.FC<BannerButtonProps> = ({ rootStore }) => {
  const { locale } = rootStore.appStore.appContext;
  const { t } = useTranslation();

  return (
    <TextButton
      as='a'
      href={getKBUrl(locale ?? 'en')}
      target='_blank'
      skin='dark'
      underline='always'
    >
      {t('editor_x_studio.banner.button')}
    </TextButton>
  );
};

export const BannerButton = withInjectedRootStore(BannerButtonComp);
